<template>
  <basePopup  ref="basePopup" :tips="tips">
    <font-size-range v-model="articleFontSize" />
  </basePopup>
</template>
<script>
import basePopup from '@/views/detailPage/components/Popup';
import FontSizeRange from '../FontSizeRange';

export default {
  name: 'fontSizeControler',
  components: {
    [basePopup.name]: basePopup,
    [FontSizeRange.name]: FontSizeRange,
  },
  data() {
    return {
      tips: '请选择要调整的字体大小'
    };
  },
  computed: {
    articleFontSize: {
      get() {
        return this.$store.state.articleFontSize;
      },
      set(value) {
        this.$store.commit('SET_ARTICLE_FONT_SIZE', value);
      },
    },
    contentClass() {
      return {
        [`article-size-${this.articleFontSize}`]: true,
      };
    },
  },
  methods: {
    showFontConfigPopup() {
      this.$refs.basePopup._showPopup();
    },
  },
};

</script>
<style lang="less" scoped>
.font-config-popup-content {
  padding: 60px 0 44px;
}

.font-config-popup-cancel {
  padding: 0 @spacing-medium;
  margin-top: 20px;
  font-size: 16px;
  color: #333;
  text-align: center;
}
</style>
